module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "copyright-page"
    }
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Legend Press Ltd, 51 Gower Street, London, WC1E 6HJ")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('a', {
    attrs: {
      "href": "mailto:info@legendpress.co.uk"
    }
  }, [_vm._v("info@legendpress.co.uk")]), _vm._v(" | "), _c('a', {
    attrs: {
      "href": "http://www.legendpress.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.legendpress.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Contents © Suzanne Harrison 2021")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("The right of the above author to be identified as the author of this work has been asserted in accordance with the Copyright, Designs and Patents Act 1988. British Library Cataloguing in Publication Data available.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("Print ISBN 978-1-78955-9-392")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Ebook ISBN 978-1-78955-9-385")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Set in Times. Printing managed by Jellyfish Solutions Ltd")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Cover design by Simon Levy | "), _c('a', {
    attrs: {
      "href": "http://www.simonlevyassociates.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.simonlevyassociates.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All characters, other than those clearly in the public domain, and place names, other than those well-established such as towns and cities, are fictitious and any resemblance is purely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copy1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in or introduced into a retrieval system, or transmitted, in any form, or by any means electronic, mechanical, photocopying, recording or otherwise, without the prior permission of the publisher. Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 60
// module chunks = 0